import { Toaster as Sonner, toast } from "sonner"
import { useTheme } from "@/components/ThemeProvider"

const Toaster = ({ ...props }) => {
  const { theme = "dark" } = useTheme()

  return (
    <Sonner
      theme={theme}
      closeButton
      {...props}
    />
  );
}

export { Toaster, toast }
